import { useState, useRef, useEffect } from 'react';
import styles from '../../style/styles/ProductOption.module.css';

export const OptionDropdown = (props) => {
    const {
        options,    // list of option objects
        isLargeType = false,
        selectedOption,
        setSelectedOption,
        placeholder = false,
        placeholderText = '',
        disabled = false,
        setToastMessage,
        setIsToastVisible
    } = props;
    
    const [isExpanded, setIsExpanded] = useState(false);

    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsExpanded((prev) => !prev);
    };

    const handleOptionClick = (idx) => {
        if (options[idx]?.soldout) {
            setToastMessage('품절된 상품입니다');
            setIsToastVisible(true);
            return;
        }
        setSelectedOption(idx);
        setIsExpanded(false);
    };
    
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsExpanded(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);
    
    return (
        <div ref={dropdownRef} className={styles.OptionDropdown__Container}>
            <div 
                className={isLargeType ? styles.OptionDropdown__Input__large : styles.OptionDropdown__Input__default} 
                onClick={toggleDropdown}
            >
                {
                    isLargeType ? (
                        <>
                        <div className={styles.OptionDropdown__Input__large__contentWrapper}>
                            {
                                selectedOption == null ? 
                                null : options[selectedOption]?.optionImageFile ? (
                                    <img src={options[selectedOption]?.optionImageFile} width={36} height={36} alt='' style={{ border: '1px solid #e1e1e1' }} />
                                ) : options[selectedOption]?.optionColor ? (
                                    <div style={{ width: 36, height: 36, backgroundColor: options[selectedOption]?.optionColor, border: '1px solid #e1e1e1' }} />
                                ) : null
                            }
                            <p className={`h6 ${selectedOption == null ? 'fc-gray-500' : 'fc-gray-800'}`}>
                                {selectedOption == null ? placeholderText : options[selectedOption]?.optionText}
                            </p>
                        </div>
                        <img
                            src={`${isExpanded ? '/img/units/custom-expanded.png' : '/img/units/custom-expand.png'}`}
                            style={{ flexShrink: 0 }}
                            width={24}
                            height={24}
                            alt=''
                        />
                        </>
                    ) : (
                        <>
                        <p className={`h6 ${selectedOption == null ? 'fc-gray-500' : 'fc-gray-800'}`}>
                            {selectedOption == null ? placeholderText : options[selectedOption]?.optionText}
                        </p>
                        <img
                            src={`${isExpanded ? '/img/units/custom-expanded.png' : '/img/units/custom-expand.png'}`}
                            style={{ flexShrink: 0 }}
                            width={24}
                            height={24}
                            alt=''
                        />
                        </>
                    )
                }
            </div>
            {isExpanded ? (
                <div className={`${styles.OptionDropdown__ItemList} ${isLargeType ? styles.OptionDropdown__ItemList__large : ''}`}>
                    <div className={styles.OptionDropdown__ItemList__Content}>
                        {
                        (disabled || options.length === 0) ? 
                        <div 
                            className={`${styles.OptionDropdown__Item__default} ${isLargeType ? styles.OptionDropdown__Item__large : ''}`}
                            style={{ alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}
                        >
                            <p className={`h6 fc-gray-500`}>
                            -----------------------------------
                            </p>
                        </div> : 
                        options.map((option, key) => (
                            <div
                                className={`${selectedOption === key 
                                    ? styles.OptionDropdown__Item__selected 
                                    : styles.OptionDropdown__Item__default} ${isLargeType ? styles.OptionDropdown__Item__large : ''}`
                                }
                                onClick={() => handleOptionClick(key)}
                                key={key}
                            >
                                {
                                    isLargeType ? 
                                        option.optionImageFile ? (
                                            <img src={option.optionImageFile} width={36} height={36} alt='' style={{ border: '1px solid #e1e1e1' }} />
                                        ) :
                                        option.optionColor ? (
                                            <div style={{ width: 36, height: 36, backgroundColor: option.optionColor, border: '1px solid #e1e1e1' }} />
                                        ) : null
                                    : null
                                }
                                <p className={`h6 ${option.soldout ? 'fc-gray-400' : 'fc-gray-800'}`}>
                                    {option.soldout ? '[품절] ' + option.optionText : option.optionText}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            ) : null}
        </div>
    );
}